import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Drawer } from '@mantine/core';
import React from 'react';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';
import { EmploymentRecordRes } from '@dealstack/shared/lib/generated';
import { useEmploymentRecordDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EmploymentRecordDrawer/hooks/useEmploymentRecordDrawer.ts';
import { EmploymentRecordForm } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EmploymentRecordDrawer/components/EmploymentRecordForm.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	hasPermission: boolean;
	opened: boolean;
	onClose: () => void;
	employmentRecord: EmploymentRecordRes | null;
}

export const EmploymentRecordDrawer = ({
	employmentRecord,
	hasPermission,
	opened,
	onClose,
}: Props) => {
	const tCapManage = useTranslationCapManage();
	const { isRequestLoading, onFormSubmit } = useEmploymentRecordDrawer(onClose);

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			transitionProps={drawerTransitionProps}
			title={
				<span data-testid={TEST_ELEMENT_IDS.CAP_EMPLOYMENT_RECORD_DRAWER_HEADING}>
					{employmentRecord
						? tCapManage('employment_record.drawer.edit_title', {
								defaultValue: 'Edit employment record',
							})
						: tCapManage('employment_record.drawer.add_title')}
				</span>
			}
		>
			<EmploymentRecordForm
				hasEditPermission={hasPermission}
				onSubmit={onFormSubmit}
				isRequestLoading={isRequestLoading}
				employmentRecord={employmentRecord}
			/>
		</Drawer>
	);
};
